import React, { Fragment } from "react";
import { Button } from "@sunrun/experience-ui-components";
import { useMediaQuery } from "react-responsive";
import styled from "@emotion/styled/macro";
import { formatNumber, formatPercent } from "../../../utils/formatHelpers";
import {
  buildLeftMiddleRightRow,
  buildLeftRightRow,
} from "../atoms/layoutAtoms";
import { useCapContext } from "../../providers/CapContext";
import { Proposal, RowProps, Term } from "../../capTypes";
import { SplatProposal } from "../../../../amplify/backend/function/OfferExpContacts/ts/public/types";
import { mobileMaxWidth } from "components/atoms/GlobalStyles";
import { getComparisonSelfSupplyPercentFromValue } from "utils/selfSupplyChartData";

const Production = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;

  p {
    margin: 0 auto;
  }
  p,
  button {
    padding: 0;
    margin: auto;
  }
`;

const SystemRows = ({
  viewType,
  isLoading = true,
  showSelfSupply = false,
  toggleProductionModal,
}: RowProps) => {
  const { originalProposal, activeProposal, isNonSolar, sow } = useCapContext();
  const isMobile = useMediaQuery({ maxWidth: mobileMaxWidth });

  const getEstimatedYear1Production = (
    activeProposal: Proposal | undefined,
    originalProposal: SplatProposal | undefined
  ): number | undefined => {
    if (activeProposal?.changeOrderInformation === "NO_SIGNATURES_REQUIRED") {
      return originalProposal?.year1ProductionForPricing;
    }

    return activeProposal?.year1ProductionForPricing;
  };

  const data: Array<Term> = isNonSolar
    ? []
    : ([
        [
          "Year 1 production",
          `${formatNumber(
            originalProposal?.year1ProductionForPricing ?? 0
          )} kWh`,
          <Production>
            <Button color="secondary" size="sm" onClick={toggleProductionModal}>
              Solar production
            </Button>
            <p>
              {formatNumber(
                getEstimatedYear1Production(activeProposal, originalProposal) ??
                  0
              )}{" "}
              kWh
            </p>
          </Production>,
        ],
        [
          "System size",
          `${originalProposal?.systemSize} kW DC`,
          `${activeProposal?.systemSize} kW DC`,
        ],
        showSelfSupply
          ? [
              "Est. annual self supply",
              `${getComparisonSelfSupplyPercentFromValue(
                sow?.originalProposal?.annualPercentSelfSupply
              )}%`,
              `${getComparisonSelfSupplyPercentFromValue(
                sow?.annualPercentSelfSupply
              )}%`,
            ]
          : [
              "Est. energy offset",
              `${formatPercent((originalProposal?.usageOffset ?? 0) / 100)}`,
              `${formatPercent((activeProposal?.usageOffset ?? 0) / 100)}`,
            ],
      ] as Array<Term>);
  let rows = [];
  if (viewType === "Single") {
    rows = data.map((term) => {
      return buildLeftRightRow(term, true, isLoading, isMobile);
    });
  } else {
    rows = data.map((term) => {
      return buildLeftMiddleRightRow(term, true, isLoading, isMobile);
    });
  }
  return (
    <>
      {rows.map((row, i) => (
        <Fragment key={row.key ?? i}>{row}</Fragment>
      ))}
    </>
  );
};

export { SystemRows };
